"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransportFactory = void 0;
var apollo_link_logger_1 = __importDefault(require("apollo-link-logger"));
var TransportFactory = /** @class */ (function () {
    function TransportFactory(_linkBuilderFactory, opts) {
        this._linkBuilderFactory = _linkBuilderFactory;
        this.opts = opts;
    }
    TransportFactory.prototype.getBuilder = function () {
        var linkBuilder = this._linkBuilderFactory.make();
        var isDevMode = false;
        if (typeof localStorage !== 'undefined') {
            try {
                isDevMode = localStorage.getItem('debug-info') !== null;
            }
            catch (e) {
                console.error(e);
            }
        }
        if (isDevMode) {
            return linkBuilder.addLink(apollo_link_logger_1.default);
        }
        return linkBuilder;
    };
    TransportFactory.prototype.createHeaders = function () {
        var defaultHeaders = { 'X-Auth-Token': this.opts.token };
        return this.opts.headers || defaultHeaders;
    };
    return TransportFactory;
}());
exports.TransportFactory = TransportFactory;
//# sourceMappingURL=TransportFactory.js.map